import { render, staticRenderFns } from "./SidebarNav.vue?vue&type=template&id=457c2c78&scoped=true"
import script from "./SidebarNav.ts?vue&type=script&lang=js&external"
export * from "./SidebarNav.ts?vue&type=script&lang=js&external"
import style0 from "./SidebarNav.vue?vue&type=style&index=0&id=457c2c78&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457c2c78",
  null
  
)

export default component.exports